import { option } from "../../../helpers/DropDownOption";
import { PastEventOptions } from "../Search/options/PastEventOptions";
import { CertificatesOptions } from "../Search/options/CertificatesOptions"

const searchColumns = {
    PastEvent : [   
        {name:'Selector', key:'selector',type:'select' ,size:"12", options:PastEventOptions },
        {name:'Name of Event', key:'name', type:'text', size:"12",condition: { key: "selector", value: 'name'}},
        {name:'School', key:'brand', type:'Apiselect' ,size:"12", options:[], url:"brands?_sort=name:ASC"
        ,condition: { key: "selector", value: 'brand'} },
        {name:'Department', key:'department', type:'Apiselect',size:"12", options:[], url:"departments?_sort=name:ASC"
        ,condition: { key: "selector", value: 'department'}},
        {name:'Activity', key:'activity', type:'select',size:"12", options:option.activityOption
        ,condition: { key: "selector", value: 'activity'}},
        {name:'Event Type', key:'event_type', type:'select', size:"12", options:option.eventTypeOption
        ,condition: { key: "selector", value: 'event_type'}},
        {name:'Event Type', key:['start_date','end_date'], type:'dateFromTo', size:"6"
        ,condition: { key: "selector", value: 'date'}}
    ],

    certificates : [
        {name:'Selector', key:'selector',type:'select' ,size:"12", options:CertificatesOptions },
        {name:'Student Email', key:'email', type:'text', size:"12",condition: { key: "selector", value: 'email'}},
    ]
}

export default searchColumns;